<template>
    <iframe 
        :src="docURL" 
        width="100%" 
        :height="height" 
        :style="'min-height:' + height + ' !important'"
    />
</template>

<script>
export default {
  name: 'SimplePDFViewer',
  props: {
    docURL:String,
    height:String
  },
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  }
}
</script>